"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Helper / bigfix / workaround method for registration step 4
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.registration = {
    initialize: function () {
        'use strict';
        // use hard JS redirect due to datamints_feuser location redirect unflexibility
        // location header redirect must be deactivated in typo3-extension!
        // TODO messy logic - could be solved in XCLASS?
        if ($('body').hasClass('mw-logged-in') && $('#datamints_feuser_261_form').length > 0) {
            $('#datamints_feuser_261_form').hide();
            window.location = '/kundenservice/kunden-login/registrieren/?tx_datamintsfeuser_pi1[261][submit]=approvalcheck';
        }
    }
};
exports.default = {};
